import { BehaviorSubject } from 'rxjs';
import { Component, Input, OnInit, OnChanges, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

// environments
import { environment } from 'src/environments/environment';

// custom enums
import { PRODUCT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { usersType } from 'src/app/core/enums/user/user-type';
import { Rent_Type } from 'src/app/core/enums/ads/rent-types';
import { Price_Type } from 'src/app/core/enums/ads/price-types';
import { BILL_TYPE } from 'src/app/core/enums/ads/bill/bill-type';
import { STATUS_TYPE } from 'src/app/core/enums/ads/status-types';
import { Contract_Type } from 'src/app/core/enums/ads/contract-types';
import { CRUD_COMPONENT } from 'src/app/core/enums/global/crud-types';
import { FEATURES_TYPE } from 'src/app/core/enums/features/features-type';

// services
import { AuthService } from 'src/app/core/services/user/auth.service';
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// interfaces
import { IUserInfo  } from 'src/app/core/interfaces/user/user-info';
import { IBillInfo } from 'src/app/core/interfaces/ads/ads-bill-info';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

// static
import { listOfRentType } from 'src/app/core/reusable-objects/globle-objs/rent-list';

// component
import { BillDataComponent } from 'src/app/shared.standalone/bill-data/bill-data.component';
import { OrderDetailsComponent } from 'src/app/shared.standalone/order-details/order-details.component';

// directives
import { ImgUrlCheckDirective } from 'src/app/core/directives/img/img-url-check.directive';


@Component({
  standalone: true,
  selector: 'app-preview-ad-data',
  templateUrl: './preview-ad-data.component.html',
  styleUrls: ['./preview-ad-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    BillDataComponent,
    OrderDetailsComponent,
    ImgUrlCheckDirective,
    NgIf, NgFor, NgClass, NgSwitch, NgSwitchCase, NgSwitchDefault, DatePipe, AsyncPipe,
  ]
})
export class PreviewAdDataComponent implements OnInit, OnChanges {

  /**
   * OutPuts
   */

  /**
   * 
   */
  @Output() bill =  new EventEmitter<IBillInfo>();

  /**
   * Inputs
   */

  /**
   * 
   */
  @Input({ alias: 'crud' }) public Crud: CRUD_COMPONENT = null;

  /**
   * 
   */
  @Input({ alias: 'errorMsg' }) public ErrorMsg: any[] = null;

  /**
   * 
   */
  @Input({ alias: 'adType' }) public AdType: PRODUCT_TYPE = null

  /**
   * 
   */
  @Input({ alias: 'showBill' }) public ShowBill: boolean = false

  /**
   * 
   */
  @Input({ alias: 'info' }) Info: IAdvertisementResponse = null;


  /**
   * fields
   */

  /**
   * 
   */
  private _isLoading: boolean = false

  /**
   * 
   */
  public billInfo: IBillInfo = null;

  constructor(
    private _auth: AuthService,
    private _api: ApiResponseService,
    private _adOperation: AdOperationService,
  ) {}

  /**
   * Getters & Setters
   */

  /**
   * 
   * @returns 
   */
  public get UserInfo(): BehaviorSubject<IUserInfo > {
    return this._auth.userInfo
  }

  /**
   * isLand
   */
  public get isLand(): boolean {
    
    /**
     * 
     */
    return this._adOperation.isLand(this.Info.category.type)

  }   

  /**
   * @description check if current category type from types has Bundled Ads
   * @returns if BL or PL or VL return true else false
   */
  public get IsHasBundledAds(): boolean {
    return this._adOperation.IsHasBundledAds(this.Info.category.type)
  }   

  /**
   * 
   */
  public get flatAreas(): string {

    if (Array.isArray(this.Info?.area)) {

      return `${this.Info?.area.map(area => area.areaName).slice(0, 9).join(' - ')} ${this.Info.area.length > 9 ? ` - اكثر من... ${this.Info.area.length - 9}` : ''}`

    }

    return this.Info?.area?.areaName

  }  

  /**
   * 
   */
  public get AdTypes(): typeof PRODUCT_TYPE {
    return PRODUCT_TYPE
  }

  /**
   * 
   */
  public get UsersType(): typeof usersType {
    return usersType
  }
  
  /**
   * 
   */
  public get PriceType(): typeof Price_Type {
    return Price_Type
  }
  
  /**
   * 
   */
  public get StatusType(): typeof STATUS_TYPE {
    return STATUS_TYPE
  }
  
  /**
   * 
   */
  public get CrudType(): typeof CRUD_COMPONENT {
    return CRUD_COMPONENT
  }
  
  /**
   * 
   */
  public get ContractType(): typeof Contract_Type {
    return Contract_Type
  }

  /**
   * 
   */
  public get RentType(): typeof Rent_Type {
    return Rent_Type
  }  

  /**
   * 
   */
  public get FeaturesType(): typeof FEATURES_TYPE {
    return FEATURES_TYPE
  }

  /**
   * 
   * @returns 
   */
  public get ContractTypeTitle(): string {
    return this.Info?.contractType === Contract_Type.SE ? 'بيع' : 'تاجير'
  }

  /**
   * 
   * @returns 
   * @deprecated rentType not avalible now because all ads by default is sale
   */
  public get RentTypeTitle(): string {
    return null;
    // return listOfRentType.find(rent => rent.id === this.Info?.rentType)?.name
  }

  /**
   * 
   * @returns 
   */
  public get Price(): string {

    // ES6 Destruction
    const { price } = this.Info;

    /**
     * handler with request
     */
    // if (this.AdType === PRODUCT_TYPE.request) {

    //   return priceFrom != null && priceTo != null ? (`من ${priceFrom?.toLocaleString()} الي ${priceTo?.toLocaleString()}`) : 'لم يحدد'

    // }

    /**
     * with adv
     */
    return price?.toLocaleString()

  }

  /**
   * 
   * @returns 
   */
  public get Size(): string {

    // ES6 Destruction
    const { size } = this.Info;

    /**
     * handler with request
     */
    // if (this.AdType === PRODUCT_TYPE.request) {

    //   return sizeFrom != null && sizeTo != null ? (`من ${sizeFrom?.toLocaleString()} الي ${sizeTo?.toLocaleString()}`) : 'لم يحدد'

    // }

    /**
     * with adv
     */
    return size?.toLocaleString()

  }

  /**
   * 
   */
  public get PriceTypeTitle(): string | null {
    return this._adOperation.PriceTypeTitle(this.Info.priceType)
  }

  /**
   * 
   */
  ngOnChanges() {

    /**
     * call
     */
    this._getBillData();

  }

  /**
   * Methods
   */

  /**
   * 
   */
  ngOnInit(): void {console.log(this.Info)}


  private _getBillData(): void {

    /**
     * handler error
     */
    if (this.Info === null) return null;
    else if (this.ShowBill != true) return null;
    else if (this.AdType !== PRODUCT_TYPE.advertisement) return null;
    else if (this.UserInfo.value.type !== usersType.normalUser) return null;

    /**
     * 
     */
    this
      ._api
      .getBillInfo({ data: { billType: BILL_TYPE.add }})
      .subscribe(
        (res) => {
          
          /**
           * 
           */
          this.billInfo = res;

          /**
           * 
           */
          this.bill.emit(res);

          /**
           * 
           */
          this._isLoading = false;          

        },
        err => this._isLoading = false
      )    

  }

  /**
   * 
   * @param index 
   * @param item 
   * @returns 
   */
  public trackByFn(index: number, item: any): number {
    return item.id; // or any unique property of the item
  }

}
